<template>
  <div id="ImageCapture" class="page-container">
    <div v-if="activeComponent == 'recognition-with-core-values'">
      <chart-recognition-core-value></chart-recognition-core-value>
    </div>
    <div v-else>else</div>
  </div>
</template>
  
<script>
export default {
  name: "ImageCapture",
  components: {
    chartRecognitionCoreValue: require("./image-capture/recognition-with-core-values.vue").default,
  },
  data() {
    return {
      activeComponent: "#icons",
    };
  },
  created() {
    const path = this.$router.currentRoute.path;
    const subPath = path.split("/");
    this.activeComponent = subPath[2];
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
  